/**
 *
 * IconTextBadge
 *
 */
import React, { memo } from 'react';
import IconText, { IconTextStyleProps } from '../IconText';
import { useTheme } from '@mui/material';

interface Props extends IconTextStyleProps {
  icon: React.ReactNode;
  text: React.ReactNode;
}

export const IconTextBadge = memo((props: Props) => {
  const theme = useTheme();
  return (
    <>
      <IconText
        text={props.text}
        icon={props.icon}
        wrapperStyle={{
          borderRadius: 22,
          border: `1px solid ${theme.palette.border}`,
          width: 'max-content',
          padding: theme.spacing(0.5, 1),
          lineHeight: '22px',
          backgroundColor: theme.palette.primary.light,
          ...props.wrapperStyle,
        }}
        iconStyle={props.iconStyle}
        textStyle={props.textStyle}
      />
    </>
  );
});
